import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  productsFindMeClickTimes: {}, // id: timestamp
};

export const FIND_ME_BUTTON_CLICK = 'FIND_ME_BUTTON_CLICK';

const clickTrackerSlice = createSlice({
  initialState,
  name: 'clickTracker',
  reducers: {
    recordClickTime: (state, action) => {
      const { id, timestamp, clickType } = action.payload;
      switch (clickType) {
        case FIND_ME_BUTTON_CLICK:
          state.productsFindMeClickTimes[id] = timestamp;
          break;
        default:
      }
    },
  },
});

export const { recordClickTime } = clickTrackerSlice.actions;
export default clickTrackerSlice.reducer;
